/* eslint-disable max-classes-per-file */

type ErrorTranslation = {
  key: string
  context?: Record<string, unknown>
}

export abstract class CalculatorError extends Error {
  public abstract getTranslation(): ErrorTranslation
}

export class OutdoorTemperatureMissingError extends CalculatorError {
  public getTranslation(): ErrorTranslation {
    return {
      key: 'calculator.error.outdoorTemperatureMissing',
    }
  }
}

export class CalculatorBalanceError extends CalculatorError {
  public getTranslation(): ErrorTranslation {
    return {
      key: 'calculator.error.balanceError',
    }
  }
}

export class PricingModelMissingError extends CalculatorError {
  public constructor(private versionName: string) {
    super()
  }

  public getTranslation(): ErrorTranslation {
    return {
      key: 'calculator.error.pricingModelMissing',
      context: { versionName: this.versionName },
    }
  }
}
